import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const grpc = {};
grpc.web = require('grpc-web');

const store = new Vuex.Store({
  data () {
    return {
      appsStreams: []
    }
  },
  state: {
    error: {
      is: false,
      code: 0,
      message: ''
    }
  },
  mutations: {
    updateError(state, data) {
      state.error.is = true;
      state.error.code = data.code;
      if (data.message) {
        state.error.message = data.message;
      } else if (data.details) {
        state.error.message = data.details;
      } else {
        state.error.message = '('+data+')';
      }
    }
  },
  getters: {
    error: (state) => {
      return state.error;
    }
  },
  actions: {
  }
});

export default store;